import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.general.channelInfoSettings.title',
    defaultMessage: 'Channel information',
    description: 'title of the channel information settings on the configuration page',
  },
  subtitle: {
    id: 'pages.settings.general.channelInfoSettings.subtitle',
    defaultMessage: 'Change the channel information',
    description: 'subtitle of the channel information settings on the configuration page',
  },
  feedback: {
    channelInfoSettingsUpdated: {
      id: 'pages.settings.general.channelInfoSettings.feedback.channelInfoSettingsUpdated',
      defaultMessage: 'Channel information saved',
      description: 'feedback on the successful update of channel information settings',
    },
    channelInfoSettingsNotUpdated: {
      id: 'pages.settings.general.channelInfoSettings.feedback.channelInfoSettingsNotUpdated',
      defaultMessage: 'Channel information could not be saved',
      description: 'feedback on the failed update of channel information settings',
    },
  },
  editDrawer: {
    title: {
      id: 'pages.settings.general.channelInfoSettings.editDrawer.title',
      defaultMessage: 'Edit channel information',
      description: 'title of the edit channel information drawer',
    },
    urlField: {
      label: {
        id: 'properties.siteUrl',
        defaultMessage: 'Website url',
        description: 'label of the url field',
      },
    },
    logoField: {
      label: {
        id: 'properties.logo',
        defaultMessage: 'Logo',
        description: 'label of the logo field',
      },
    },
    nameField: {
      label: {
        id: 'properties.name',
        defaultMessage: 'Name',
        description: 'label of the name field',
      },
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
};

export default defineMessages(translations);
